export default "__VITE_ASSET__DUTOLBWj__"